import { CollaborationFilter, ProductFilter } from "@/components/filters/extra-filters";
import { PillField } from "@/components/filters/pill-field";
import { PerformanceSimpleRange } from "@/components/filters/range-filters";
import { FilterPanelContainer, FilterPanelHeader } from "@/components/filters/shared";
import { Form, FormField, FormItem, FormLabel } from "@/components/ui/form";
import { useFilters } from "@/providers/filter-provider";

type SampleRequestsFilterPanelProps = {
  open: boolean;
  close: () => void;
  clearAll?: () => void;
};

const BRAND_SAFETY_OPTIONS = ["low", "high"];

export const SampleRequestsFilterPanel = ({ open, close, clearAll }: SampleRequestsFilterPanelProps) => {
  const { form, isActive, reset } = useFilters();

  const handleClear = () => {
    clearAll?.();
    reset();
  };

  return (
    <FilterPanelContainer open={open}>
      <FilterPanelHeader onClear={handleClear} onClose={close} />
      <div className="flex-1 overflow-y-auto pt-4 px-6 pb-6">
        <Form {...form}>
          <div className="flex flex-col gap-6">
            {isActive("sampleBrandSafety") && (
              <FormField
                control={form.control}
                name="sampleBrandSafety"
                render={({ field }) => (
                  <FormItem className="flex flex-col gap-2">
                    <FormLabel className="text-sm text-tertiary">Brand Safety</FormLabel>
                    <PillField
                      value={field.value}
                      options={BRAND_SAFETY_OPTIONS}
                      onChange={field.onChange}
                      getLabel={(option) => (option === "high" ? "High Risk" : "Low Risk")}
                    />
                  </FormItem>
                )}
              />
            )}

            {isActive("minPostRate") && isActive("maxPostRate") && (
              <PerformanceSimpleRange
                form={form}
                label="Post Rate"
                tooltip="Post Rate"
                description="Share of a creator's approved samples that resulted in a posted video."
                minField="minPostRate"
                maxField="maxPostRate"
                min={0}
                max={100}
                format="percent"
              />
            )}

            {isActive("product") && (
              <FormField
                control={form.control}
                name="product"
                render={({ field }) => <ProductFilter field={field} />}
              />
            )}

            {isActive("collaboration") && (
              <FormField
                control={form.control}
                name="collaboration"
                render={({ field }) => <CollaborationFilter field={field} />}
              />
            )}
          </div>
        </Form>
      </div>
    </FilterPanelContainer>
  );
};
